/**
 * Trigger_Entity type guard.
 *
 * @param {any} triggerJson Trigger object from API
 * @returns {boolean} Return true if type is Trigger_Entity
 */
function validator(triggerJson: unknown): triggerJson is Trigger_Entity {
  if (typeof triggerJson === "object" && triggerJson != null) {
    Trigger_Entity.requiredFields.forEach((element) => {
      if (!Object.keys(triggerJson).includes(element))
        console.warn(`Field ${element} is null or undefined`);
    });
  }
  return true;
}

export default class Trigger_Entity {
  static requiredFields = [
    "id",
    "hookID",
    "timedelay",
    "event",
    "createdAt",
    "updatedAt",
  ];

  constructor(triggerJson: unknown) {
    if (validator(triggerJson)) {
      this.id = triggerJson.id;
      this.hookID = triggerJson.hookID;
      this.timedelay = triggerJson.timedelay;
      this.event = triggerJson.event;
      this.createdAt = triggerJson.createdAt;
      this.updatedAt = triggerJson.updatedAt;
    } else {
      throw new Error(
        "Failed to create new instance of ${ Trigger_Entity.name }: ${e}"
      );
    }
  }

  id: number;
  hookID: number;
  timedelay: number;
  event: string;
  createdAt: string;
  updatedAt: string;
}
